import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import NoInternet from './NoInternet';
import Login from './Admin/Login';
import Dashboard from './Admin/Dashboard';
import Layout from './Admin/Common/Layout';
import PrivateRoute from './PrivateRoute';
import Profile from './Admin/Profile';
import Password from './Admin/Password';
import ContactList from './Admin/Contactus/ContactList';
import ReportList from './Admin/Report/ReportList';
import PrivacyPolicy from './Admin/Cms/PrivacyPolicy';
import AboutUs from './Admin/Cms/AboutUS';
import ChildSafety from './Admin/Cms/ChildSafety';
import TermsConditions from './Admin/Cms/TermsConditions';
import { ToastContainer } from 'react-toastify';
import { initOffcanvasBackButtonHandler } from './Config';
import CitizenshipList from './Admin/Citizenship/CitizenshipList';
import AddCitizenship from './Admin/Citizenship/AddCitizenship';
import EthnicityList from './Admin/Ethnicity/EthnicityList';
import AddEthnicity from './Admin/Ethnicity/AddEthnicity';
import ReligiousList from './Admin/Religious/ReligiousList';
import AddReligious from './Admin/Religious/AddReligious';
import EducationList from './Admin/Education/EducationList';
import AddEducation from './Admin/Education/AddEducation';
import HobbieList from './Admin/Hobbie/HobbieList';
import AddHobbie from './Admin/Hobbie/AddHobbie';
import UpdateCitizenship from './Admin/Citizenship/UpdateCitizenship';
import UpdateEthnicity from './Admin/Ethnicity/UpdateEthnicity';
import UpdateReligious from './Admin/Religious/UpdateReligious';
import UpdateEducation from './Admin/Education/UpdateEducation';
import UpdateHobbie from './Admin/Hobbie/UpdateHobbie';
import IncomeList from './Admin/Income/IncomeList';
import UpdateIncome from './Admin/Income/UpdateIncome';
import AddIncome from './Admin/Income/AddIncome';
import UserList from './Admin/Users/UserList';
import ViewUser from './Admin/Users/ViewUser';

import MatchList from './Admin/Matches/MatchList';
import ViewMatch from './Admin/Matches/ViewMatch';

import SubscriptionList from './Admin/Subscription/SubscriptionList';
import AddSubscription from './Admin/Subscription/AddSubscription';
import UpdateSubscription from './Admin/Subscription/UpdateSubscription';
import UserSubscriptionList from './Admin/Subscription/UserSubscriptionList';

import TransactionList from './Admin/Transaction/TransactionList';

import SendNotification from './Admin/Notification/SendNotification';

const App = () => {
  const isAuthenticated = localStorage.getItem("token");
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    const cleanup = initOffcanvasBackButtonHandler();

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      cleanup();
    };
  }, []);




  if (!isOnline) {
    return <NoInternet />;
  }
  return (
    <>
      <Router>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/' element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" />} />
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
            <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
            <Route path="/password" element={<PrivateRoute element={<Password />} />} />
            <Route path="/userlist" element={<PrivateRoute element={<UserList />} />} />
            <Route path="/viewUser/:id" element={<PrivateRoute element={<ViewUser />} />} />

            <Route path="/citizenshipList" element={<PrivateRoute element={<CitizenshipList />} />} />
            <Route path="/addCitizenship" element={<PrivateRoute element={<AddCitizenship />} />} />
            <Route path="/updateCitizenship/:id" element={<PrivateRoute element={<UpdateCitizenship />} />} />

            <Route path="/ethnicityList" element={<PrivateRoute element={<EthnicityList />} />} />
            <Route path="/addEthnicity" element={<PrivateRoute element={<AddEthnicity />} />} />
            <Route path="/updateEthnicity/:id" element={<PrivateRoute element={<UpdateEthnicity />} />} />


            <Route path="/religiousList" element={<PrivateRoute element={<ReligiousList />} />} />
            <Route path="/addReligious" element={<PrivateRoute element={<AddReligious />} />} />
            <Route path="/updateReligious/:id" element={<PrivateRoute element={<UpdateReligious />} />} />


            <Route path="/educationList" element={<PrivateRoute element={<EducationList />} />} />
            <Route path="/addEducation" element={<PrivateRoute element={<AddEducation />} />} />
            <Route path="/updateEducation/:id" element={<PrivateRoute element={<UpdateEducation />} />} />

            <Route path="/hobbieList" element={<PrivateRoute element={<HobbieList />} />} />
            <Route path="/addHobbie" element={<PrivateRoute element={<AddHobbie />} />} />
            <Route path="/updateHobbie/:id" element={<PrivateRoute element={<UpdateHobbie />} />} />

            <Route path="/incomeList" element={<PrivateRoute element={<IncomeList />} />} />
            <Route path="/updateIncome/:id" element={<PrivateRoute element={<UpdateIncome />} />} />
            <Route path="/addIncome" element={<PrivateRoute element={<AddIncome />} />} />


            <Route path="/contactlist" element={<PrivateRoute element={<ContactList />} />} />
            <Route path="/reportlist" element={<PrivateRoute element={<ReportList />} />} />

            <Route path="/privacypolicy" element={<PrivateRoute element={<PrivacyPolicy />} />} />
            <Route path="/aboutus" element={<PrivateRoute element={<AboutUs />} />} />
            <Route path="/termsConditions" element={<PrivateRoute element={<TermsConditions />} />} />
            <Route path="/childSafety" element={<PrivateRoute element={<ChildSafety />} />} />

            <Route path="/matchlist" element={<PrivateRoute element={<MatchList />} />} />
            <Route path="/viewMatch/:id" element={<PrivateRoute element={<ViewMatch />} />} />

            <Route path="/subscriptionlist" element={<PrivateRoute element={<SubscriptionList />} />} />
            <Route path="/addSubscription" element={<PrivateRoute element={<AddSubscription />} />} />
            <Route path="/updateSubscription/:id" element={<PrivateRoute element={<UpdateSubscription />} />} />
            <Route path="/userSubscriptionslist" element={<PrivateRoute element={<UserSubscriptionList />} />} />

            <Route path="/transactionlist" element={<PrivateRoute element={<TransactionList />} />} />
            <Route path="/sendNotification" element={<PrivateRoute element={<SendNotification />} />} />

          </Route>
        </Routes>

      </Router>
      <ToastContainer />
    </>
  )
}

export default App
